import { fetchFalckdkApi } from '../utils/fetch';

/**
 * @param {string} term - The search term
 */
export async function fetchSearchSuggestions(term) {
    try {
        const fetchResponse = await fetchFalckdkApi('/api/Search/Suggestions', {
            params: {
                term,
            },
            method: 'GET',
        });

        return fetchResponse.json();
    } catch (error) {
        console.error('Error fetching search suggestions:', error);
    }
}
